module.exports = __webpack_public_path__ + "img/steps/assets--blue@2x.png";